var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrevPaginate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1L6.5 2.70435L4 4.4087L9 8",
    stroke: "#616161",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1L3.5 2.70435L1 4.4087L6 8",
    stroke: "#616161",
    strokeOpacity: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevPaginate);
export default __webpack_public_path__ + "static/media/prev-paginate.0cc5548c072b151c2bf38b2c3c71c394.svg";
export { ForwardRef as ReactComponent };